import React, { Fragment } from 'react';
import Button from '../../components/uielements/button';
import { Auth } from 'aws-amplify';
import { AuthPiece } from 'aws-amplify-react';
import { Checkbox, Col, Icon, Input, Modal, notification, Radio, Row, Select } from 'antd';
import Alert from '../../components/feedback/alert';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import sha from 'sha.js';
import endpoints from '../../aws-appsync-url';
import SignInStyleWrapper from './signin.style';
import Header from './header/index';

const { Option } = Select;
const RadioGroup = Radio.Group;
class SignIn extends AuthPiece {
  constructor(props) {
    super(props);
    this.state = {
      userExist: true,
      value: 1,
      passwordError: null,
      signupSuccess: false,
      providerFormError: '',
      showConfirmSignupForm: false,
      sysErr: '',
      sysErrBool: false,
      confError: false,
      confirmationErrMsg: '',
      phoneValue: '',
      resendSignUpBool: false,
      agree: false,
      agreeError: '',
      pricingModel: false,
      token: null,
      currentPlan: null,
      checkBoxOne: false,
      checkBoxTwo: false,
      checkBoxThree: false,
      checkBoxFour: false,
      planName: 'ESSENTIALS',
      currentIndex: 0,
      loading: false,
    };
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  clearAll = () => {
    this.setState({
      userExist: true,
      value: 1,
      passwordError: null,
      signupSuccess: false,
      providerFormError: '',
      showConfirmSignupForm: false,
      sysErr: '',
      sysErrBool: false,
      confError: false,
      confirmationErrMsg: '',
      phoneValue: '',
      resendSignUpBool: false,
      agree: false,
      agreeError: '',
    });
  };

  validateCredentials = () => {
    const { password, confirmPassword, email } = this.inputs;
    const passwordRegexp = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
    const emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!emailRegexp.test(email)) {
      this.setState({
        passwordError: 'Please enter a valid email',
      });
      return false;
    }
    if (!passwordRegexp.test(password)) {
      this.setState({
        passwordError:
          'Password must contain eight characters, at least one uppercase letter, one lowercase letter and one number',
      });
      return false;
    }
    if (password !== confirmPassword) {
      this.setState({
        passwordError: 'Password does not match with confirm password',
      });
      return false;
    }

    return true;
  };

  componentDidUpdate(prevProps, prevState) {
    // only update chart if the data has changed
    if (
      prevProps.history.location.search === '?personalInfo=true' &&
      prevProps.history.location.search !== this.props.history.location.search
    ) {
      this.setState({
        userExist: false,
      });
    }
  }

  validateProviderForm = () => {
    const { currentIndex } = this.state;
    const input = { ...this.inputs };
    delete input.password;
    delete input.checkedValue;
    delete input.confirmPassword;

    let reqFields = [];

    if (currentIndex === 0) {
      reqFields = ['firstName', 'lastName', 'email'];
    } else if (currentIndex === 1) {
      reqFields = ['phone', 'clientTerminology', 'license', 'licenseStates', 'profession'];
    } else {
      reqFields = ['therapies', 'organization', 'dbtPractice'];
    }

    let error = false;
    let fields = '';

    reqFields.forEach(key => {
      const condition = input[key] && input[key].length;
      if (!condition) {
        error = true;
        fields = `${key}, ${fields}`;
      }
    });

    if (!error && currentIndex === 0) {
      error = !this.validateCredentials();
    }

    if (!error && currentIndex === 2) {
      const { checkBoxOne, checkBoxTwo, checkBoxThree, checkBoxFour } = this.state;
      if (!(checkBoxFour && checkBoxThree && checkBoxTwo && checkBoxOne)) {
        error = true;
        this.setState({
          agreeError: 'You need to check all boxes before proceeding ahead.',
        });
      }
    }
    this.setState({
      providerFormError: `Missing required fields ${fields}`,
    });
    return !error;
  };

  stageProvider = async () => {
    this.setState({
      sysErrBool: false,
      sysErr: '',
    });

    const defaultStageProvider = {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      organization: '',
      clientTerminology: '',
      profession: '',
      treatmentSetting: [],
      totalDBTClients: 0,
      totalCBTClients: 0,
      therapies: [],
      psycTodayProfile: '',
      license: '',
      licenseStates: '',
      dbtPractice: [],
      createdAt: new Date().toISOString(),
      planId: this.state.currentPlan,
      token: this.state.token,
    };

    const input = { ...defaultStageProvider, ...this.inputs };
    input.totalCBTClients = !input.totalCBTClients ? 0 : input.totalCBTClients;
    input.totalDBTClients = !input.totalDBTClients ? 0 : input.totalDBTClients;
    delete input.password;
    delete input.confirmPassword;
    delete input.checkedValue;
    if (!input.psycTodayProfile) delete input.psycTodayProfile;
    input.email = input.email.toLowerCase();

    const url = endpoints.APIGATEWAY.BTPORTAL;
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        field: 'stageProvider',
        arguments: {
          input,
        },
      }),
    })
      .then(p => p.json())
      .catch(() => this.setState({ loading: false }))
      .then(() => this.setState({ signupSuccess: true, providerFormError: '', loading: false }));
  };

  resendSignUp = async () => {
    this.stageProvider().then(() => this.setState({ confirmSignupSuccess: true }));
  };

  handleOk = () => {
    const { email, password, firstName, lastName } = this.inputs;

    this.setState({
      sysErrBool: false,
      providerFormError: '',
      agreeError: '',
      loading: true,
    });

    Auth.signUp({
      username: new sha.sha256().update(email.toLowerCase()).digest('hex'),
      password,
      attributes: {
        email: email.toLowerCase(),
        phone_number: this.state.phone,
        given_name: firstName,
        family_name: lastName,
        name: `${firstName} ${lastName}`,
      },
    })
      .then(() => {
        this.stageProvider();
        this.setState({ showConfirmSignupForm: true });
      })
      .catch(err => {
        this.setState({
          sysErr: err.message,
          sysErrBool: true,
          loading: false,
        });
      });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
      showConfirmSignupForm: false,
    });
  };

  confirmSignup = () => {
    const { signupConfirmationCode, email } = this.inputs;
    Auth.confirmSignUp(
      new sha.sha256().update(email.toLowerCase()).digest('hex'),
      signupConfirmationCode,
    )
      .then(success => {
        this.setState({
          showConfirmSignupForm: false,
          confirmSignupSuccess: true,
        });

        if (this.state.resendSignUpBool) {
          this.stageProvider();
        }
      })
      .catch(e => {
        this.setState({
          confError: true,
          confirmationErrMsg: e.message,
        });
      });
  };

  verifyUser = async () => {
    const validate = await this.validateCredentials();
    if (!validate) {
    } else {
      this.setState({
        userExist: false,
      });
      this.props.history.push('signup?personalInfo=true');
    }
  };

  onChange = e => {
    this.setState({ value: e.target.value });
    this.inputs.profession = e.target.value !== 'Other' ? e.target.value : '';
  };

  SalutationChange = e => (this.inputs.salutation = e);

  ClientTerminologyChange = e => (this.inputs.clientTerminology = e);

  treatmentChange = e => {
    this.inputs.treatmentSetting = this.inputs.treatmentSetting || [];
    const val = e.target.value;
    const index = this.inputs.treatmentSetting.indexOf(val);
    if (index !== -1) {
      this.inputs.treatmentSetting.splice(index, 1);
    } else {
      this.inputs.treatmentSetting.push(val);
    }
  };

  therapiesChange = e => {
    this.inputs.therapies = this.inputs.therapies || [];
    const val = e.target.value;
    const index = this.inputs.therapies.indexOf(val);
    if (index !== -1) {
      this.inputs.therapies.splice(index, 1);
    } else {
      this.inputs.therapies.push(val);
    }
  };

  practiseChange = e => {
    this.inputs.dbtPractice = this.inputs.dbtPractice || [];
    const val = e.target.value;
    const index = this.inputs.dbtPractice.indexOf(val);
    if (index !== -1) {
      this.inputs.dbtPractice.splice(index, 1);
    } else {
      this.inputs.dbtPractice.push(val);
    }
  };

  isUserExist = async event => {
    const url = endpoints.APIGATEWAY.EMAILVALIDATE;
    const data = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        field: 'doesUserExist',
        arguments: {
          input: event.target.value,
        },
      }),
    }).then(res => {
      console.log(res);
      if (res && res.bodyUsed) {
        this.setState({
          isEmailExist:
            'If you have already signed up for one of our mobile apps (DBT Coach, CBT Companion etc.) please use a different email.\n',
        });
      } else {
        this.setState({
          isEmailExist: '',
        });
      }
    });
  };

  agree = ({ target }) => {
    const { checked } = target;
    this.setState({ agree: checked });
  };

  handleInputPhoneChange = phone => {
    this.setState({ phone });
    this.inputs.phone = phone;
  };

  confirmPlan = ({ token, plan, name }) => {
    this.setState({ pricingModel: false, token, currentPlan: plan, planName: name });
  };

  setDefaultPlan = () => {
    this.setState({ pricingModel: false, plan: null, token: null, planName: 'ESSENTIALS' });
  };

  onNext = () => {
    if (this.validateProviderForm()) {
      if (this.state.currentIndex === 2) {
        this.handleOk();
      } else {
        this.setState({
          currentIndex: this.state.currentIndex + 1,
          providerFormError: '',
          passwordError: '',
        });
      }
    }
  };

  renderRequiredMark = () => <span style={{ color: 'red' }}> *</span>;

  render() {
    const { currentIndex } = this.state;
    const values = this.inputs;
    // const mfaDownloadInst = 'Download Google Authenticator App from <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">Play Store</a> or <a href="https://itunes.apple.com/in/app/google-authenticator/id388497605" target="_blank">App Store</a>.'
    return (
      <SignInStyleWrapper className='isoSignInPage'>
        <Header {...this.props} isSignup />
        <div
          className='content'
          style={{
            minHeight: 'calc(100vh - 60px)',
            padding: '30px 0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div className='bg-img' />
          {this.state.signupSuccess && !this.state.showConfirmSignupForm ? (
            <Row className='signup-row'>
              <div className='auth-box'>
                <div
                  className={
                    this.state.userExist
                      ? 'isoLoginContentWrapper personalInfo'
                      : 'isoLoginContentWrapper personalInfo'
                  }
                >
                  <div className='signup-confirmation'>
                    {!this.state.confirmSignupSuccess
                      ? 'Thank you for signing up to our Therapist Portal but you will need to verify email at the time of login to use our services.'
                      : 'Thank you for signing up to our Clinician Portal. We will get in touch with you soon about next steps.'}
                    <br />
                    <Button
                      onClick={() => this.props.history.push('/signin')}
                      className='bt_portal-button -primary margin-top-one'
                    >
                      Login
                    </Button>
                  </div>
                </div>
              </div>
            </Row>
          ) : (
            <Row className='signup-row'>
              <div className='auth-box'>
                {currentIndex !== 0 ? (
                  <div
                    className='back-button'
                    onClick={() => this.setState({ currentIndex: currentIndex - 1 })}
                  >
                    <Icon type='arrow-left' />
                    Back
                  </div>
                ) : null}
                <div className='isoLoginContent' hidden={currentIndex !== 0}>
                  <div className='isoLogoWrapper primary-text'>Personal Information</div>
                  <div className='isoSignInForm' style={{ paddingBottom: 100 }}>
                    {/* <Federated federated={federated_data} onStateChange={this.handleAuthStateChange} /> */}
                    {this.state.passwordError ? (
                      <Alert
                        message={this.state.passwordError}
                        type='error'
                        showIcon
                        style={{ marginBottom: '20px' }}
                      />
                    ) : null}

                    <Row gutter={16}>
                      <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                        <Input
                          size='large'
                          className='bt_portal-input'
                          type='text'
                          placeholder='Enter First Name'
                          name='firstName'
                          onChange={this.handleInputChange}
                          defaultValue={values.firstName}
                        />
                        {this.state.providerFormError.indexOf('firstName') > -1 ? (
                          <small style={{ color: 'red' }}>First Name is required</small>
                        ) : null}
                      </Col>
                      <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                        <Input
                          size='large'
                          type='text'
                          className='bt_portal-input'
                          placeholder='Enter Last Name'
                          name='lastName'
                          onChange={this.handleInputChange}
                          defaultValue={values.lastName}
                        />
                        {this.state.providerFormError.indexOf('lastName') > -1 ? (
                          <small style={{ color: 'red' }}>Last Name is required</small>
                        ) : null}
                      </Col>
                    </Row>

                    <div className='gutter-row isoInputWrapper'>
                      <Input
                        size='large'
                        type='text'
                        className='bt_portal-input'
                        placeholder='Enter Email - Use a different email than that you use for client facing apps (DBT Coach, CBT Companion etc.)'
                        name='email'
                        onChange={this.handleInputChange}
                        onBlur={this.isUserExist}
                        defaultValue={values.email}
                      />
                      {this.state.providerFormError.indexOf('email') > -1 ? (
                        <small style={{ color: 'red' }}>Email address is required</small>
                      ) : this.state.isEmailExist ? (
                        <div
                          className='instruction'
                          style={{ marginBottom: 20, lineHeight: '21px', color: '#bababa' }}
                        >
                          <Icon type='info-circle' theme='twoTone' />
                          <small style={{ marginLeft: 5 }}>{this.state.isEmailExist}</small>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>

                    <Row gutter={16}>
                      <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                        <Input
                          size='large'
                          type='password'
                          className='bt_portal-input'
                          placeholder='Enter Password'
                          name='password'
                          onChange={this.handleInputChange}
                          defaultValue={values.password}
                        />
                      </Col>
                      <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                        <Input
                          size='large'
                          type='password'
                          className='bt_portal-input'
                          placeholder='Confirm Password'
                          name='confirmPassword'
                          onChange={this.handleInputChange}
                          defaultValue={values.confirmPassword}
                        />
                      </Col>
                      <p className='light-text' style={{ fontSize: 15, marginTop: 10 }}>
                        {' '}
                        8+ Characters, 1 Number, 1 Uppercase, 1 Lowercase{' '}
                      </p>
                    </Row>
                  </div>
                </div>
                <div className='isoLoginContent' hidden={currentIndex !== 1}>
                  <div className='isoLogoWrapper primary-text'>Practice Details</div>
                  <div className='isoSignInForm'>
                    <Fragment>
                      <Row gutter={16}>
                        <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                          <Input
                            size='large'
                            className='bt_portal-input'
                            type='text'
                            placeholder='Organization / Clinic'
                            name='organization'
                            onChange={this.handleInputChange}
                            defaultValue={values.organization}
                          />
                          {this.state.providerFormError.indexOf('organization') > -1 ? (
                            <small style={{ color: 'red' }}>Organization is required</small>
                          ) : null}
                        </Col>
                        <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                          {/* <Input size="large" type="text" placeholder="Phone Number" name="phone" onChange={this.handleInputChange} /> */}
                          <PhoneInput
                            country='US'
                            defaultCountry='US'
                            className='ant-input ant-input-lg signup-phone-input'
                            placeholder='Phone that accepts text messages'
                            displayInitialValueAsLocalNumber
                            onChange={this.handleInputPhoneChange}
                            value={this.state.phone}
                          />
                          {this.state.providerFormError.indexOf('phone') > -1 ? (
                            <small style={{ color: 'red' }}>Phone Number is required</small>
                          ) : null}
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                          <Select
                            name='clientTerminology'
                            placeholder='Client Terminology'
                            style={{ width: '100%', height: '41px' }}
                            onChange={this.ClientTerminologyChange}
                            className='bt_portal-select'
                            dropdownClassName='signup-select'
                            defaultValue={values.clientTerminology}
                          >
                            <Option value='Patient'>Patient</Option>
                            <Option value='Client'>Client</Option>
                          </Select>
                          {this.state.providerFormError.indexOf('clientTerminology') > -1 ? (
                            <small style={{ color: 'red', fontSize: 16 }}>
                              Client Terminology is required
                            </small>
                          ) : null}
                        </Col>
                        <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                          <Input
                            size='large'
                            className='bt_portal-input'
                            type='text'
                            placeholder='License Number'
                            name='license'
                            autoComplete='off'
                            id='license'
                            onChange={this.handleInputChange}
                            defaultValue={values.license}
                          />
                          {this.state.providerFormError.indexOf('license') > -1 ? (
                            <small style={{ color: 'red' }}>License Number is required</small>
                          ) : null}
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                          <Input
                            size='large'
                            type='text'
                            className='bt_portal-input'
                            placeholder='License State'
                            name='licenseStates'
                            onChange={this.handleInputChange}
                            defaultValue={values.licenseStates}
                          />
                          {this.state.providerFormError.indexOf('licenseStates') > -1 ? (
                            <small style={{ color: 'red' }}>License State is required</small>
                          ) : null}
                        </Col>

                        <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                          <Input
                            size='large'
                            type='text'
                            className='bt_portal-input'
                            placeholder='Psychology Today Profile'
                            name='psycTodayProfile'
                            onChange={this.handleInputChange}
                            defaultValue={values.psycTodayProfile}
                          />
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                          <label
                            className='light-text'
                            style={{ fontWeight: 'normal', fontSize: 15 }}
                          >
                            {' '}
                            Total CBT clients
                          </label>
                          <Input
                            size='large'
                            type='number'
                            min={0}
                            className='bt_portal-input'
                            placeholder='Total CBT clients'
                            name='totalCBTClients'
                            onChange={this.handleInputChange}
                            defaultValue={values.totalCBTClients}
                          />
                          {/* (this.state.providerFormError.indexOf("totalCBTClients") > -1) ? <small style={{color: 'red'}}>This is required</small> : null */}
                        </Col>
                        <Col className='gutter-row isoInputWrapper' xs={24} sm={24} md={12} xl={12}>
                          <label
                            className='light-text'
                            style={{ fontWeight: 'normal', fontSize: 15 }}
                          >
                            {' '}
                            Total DBT clients
                          </label>
                          <Input
                            size='large'
                            type='number'
                            min={0}
                            className='bt_portal-input'
                            placeholder='Total DBT clients'
                            name='totalDBTClients'
                            onChange={this.handleInputChange}
                            defaultValue={values.totalDBTClients}
                          />
                          {/* (this.state.providerFormError.indexOf("totalDBTClients") > -1) ? <small style={{color: 'red'}}>This is required</small> : null */}
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        {this.state.value === 'Other' ? (
                          <Col
                            style={{ marginBottom: '10px' }}
                            className='gutter-row isoInputWrapper'
                            xs={24}
                            sm={24}
                            md={24}
                            xl={24}
                          >
                            <Input
                              size='large'
                              type='text'
                              className='bt_portal-input'
                              placeholder='Profession'
                              name='profession'
                              onChange={this.handleInputChange}
                              defaultValue={values.profession}
                            />
                            {this.state.providerFormError.indexOf('profession') > -1 ? (
                              <small style={{ color: 'red' }}>Profession is required</small>
                            ) : null}
                          </Col>
                        ) : null}
                      </Row>
                      <Row gutter={16} style={{ margin: '24px 0 0px' }}>
                        <Col
                          className='gutter-row isoInputWrapper'
                          md={24}
                          style={{ padding: '0 0' }}
                        >
                          <Col
                            className='gutter-row isoInputWrapper'
                            md={24}
                            style={{ padding: 0 }}
                          >
                            <h4 className='sub-title'>
                              Select Profession {this.renderRequiredMark()}
                            </h4>
                            <RadioGroup onChange={this.onChange} value={this.state.value}>
                              <Row>
                                <Col span={12} style={{ marginBottom: '10px' }}>
                                  <Radio value='Psychologist'>Psychologist</Radio>
                                </Col>
                                <Col span={12} style={{ marginBottom: '10px' }}>
                                  <Radio value='Medical Doctor'>Medical Doctor</Radio>
                                </Col>
                                <Col span={12} style={{ marginBottom: '10px' }}>
                                  <Radio value='Psychiatrist'>Psychiatrist</Radio>
                                </Col>
                                <Col span={12} style={{ marginBottom: '10px' }}>
                                  <Radio value='Social Worker'>Social Worker</Radio>
                                </Col>
                                <Col span={12} style={{ marginBottom: '10px' }}>
                                  <Radio value='Nurse Practitioner'>Nurse Practitioner</Radio>
                                </Col>
                                <Col span={12} style={{ marginBottom: '10px' }}>
                                  <Radio value='Other'>Other</Radio>
                                </Col>
                              </Row>
                            </RadioGroup>
                            {this.state.providerFormError.indexOf('profession') > -1 ? (
                              <small style={{ color: 'red' }}>Profession is required</small>
                            ) : null}
                          </Col>
                        </Col>
                      </Row>
                      <Row>
                        <Col className='gutter-row isoInputWrapper' md={24}>
                          <Col className='gutter-row isoInputWrapper' md={24}>
                            <h4 className='sub-title'>Type of your practice</h4>

                            <Checkbox.Group
                              defaultValue={values.treatmentSetting}
                              style={{ width: '100%' }}
                            >
                              <Row>
                                <Col
                                  onChange={this.treatmentChange}
                                  span={12}
                                  style={{ marginBottom: '10px' }}
                                >
                                  <Checkbox value='Outpatient'>Outpatient</Checkbox>
                                </Col>
                                <Col
                                  onChange={this.treatmentChange}
                                  span={12}
                                  style={{ marginBottom: '10px' }}
                                >
                                  <Checkbox value='IntensiveOutpatient'>
                                    Intensive Outpatient
                                  </Checkbox>
                                </Col>
                                <Col
                                  onChange={this.treatmentChange}
                                  span={12}
                                  style={{ marginBottom: '10px' }}
                                >
                                  <Checkbox value='PartialHospitalization'>
                                    Partial Hospitalization
                                  </Checkbox>
                                </Col>
                                <Col
                                  onChange={this.treatmentChange}
                                  span={12}
                                  style={{ marginBottom: '10px' }}
                                >
                                  <Checkbox value='Residential'>Residential</Checkbox>
                                </Col>
                                <Col
                                  onChange={this.treatmentChange}
                                  span={12}
                                  style={{ marginBottom: '10px' }}
                                >
                                  <Checkbox value='Hospitalization'>Hospitalization</Checkbox>
                                </Col>
                              </Row>
                            </Checkbox.Group>
                          </Col>
                        </Col>
                      </Row>
                    </Fragment>
                  </div>
                </div>
                <div className='isoLoginContent' hidden={currentIndex !== 2}>
                  <div className='isoLogoWrapper primary-text'>Clinician Information</div>
                  <div className='isoSignInForm'>
                    {this.state.sysErrBool ? (
                      <Alert
                        message={
                          this.state.sysErr?.includes('EMAIL_EXISTS')
                            ? 'You have already signed up for clinician portal or one of our mobile apps (DBT Coach, CBT Companion etc.) with this email. Please use a different email.'
                            : this.state.sysErr
                        }
                        type='error'
                        showIcon
                        style={{ marginBottom: '20px' }}
                      />
                    ) : null}
                    <Row style={{ display: 'unset' }}>
                      <Col className='gutter-row isoInputWrapper' md={24}>
                        <h4 className='sub-title'>Therapies {this.renderRequiredMark()}</h4>
                        <Checkbox.Group defaultValue={values.therapies} style={{ width: '100%' }}>
                          <Row style={{ display: 'unset' }}>
                            <Col onChange={this.therapiesChange} md={8} xl={8}>
                              <Checkbox value='DBT'>DBT</Checkbox>
                            </Col>
                            <Col onChange={this.therapiesChange} xl={8}>
                              <Checkbox value='CBT'>CBT</Checkbox>
                            </Col>
                            <Col onChange={this.therapiesChange} xl={8}>
                              <Checkbox value='ACT'>ACT</Checkbox>
                            </Col>
                            <Col onChange={this.therapiesChange} xl={8}>
                              <Checkbox value='EMDR'>EMDR</Checkbox>
                            </Col>
                            <Col onChange={this.therapiesChange} xl={8}>
                              <Checkbox value='IFS'>IFS</Checkbox>
                            </Col>
                            <Col onChange={this.therapiesChange} xl={8}>
                              <Checkbox value='REBT'>REBT</Checkbox>
                            </Col>
                            <Col onChange={this.therapiesChange} xl={8}>
                              <Checkbox value='RODBT'>RODBT</Checkbox>
                            </Col>
                          </Row>
                        </Checkbox.Group>
                        {this.state.providerFormError.indexOf('therapies') > -1 ? (
                          <small style={{ color: 'red' }}>Please select at least one therapy</small>
                        ) : null}
                      </Col>
                      <Col className='gutter-row isoInputWrapper' md={24} style={{ marginTop: 20 }}>
                        <h4 className='sub-title'>Practice Settings {this.renderRequiredMark()}</h4>
                        <Checkbox.Group defaultValue={values.dbtPractice} style={{ width: '100%' }}>
                          <Row style={{ display: 'unset' }}>
                            <Col onChange={this.practiseChange} md={8} xl={8}>
                              <Checkbox value='Individual'>Individual</Checkbox>
                            </Col>
                            <Col onChange={this.practiseChange} xl={8}>
                              <Checkbox value='GroupSkills'>Group Skills</Checkbox>
                            </Col>
                          </Row>
                        </Checkbox.Group>
                        {this.state.providerFormError.indexOf('dbtPractice') > -1 ? (
                          <small style={{ color: 'red' }}>Select a practice</small>
                        ) : null}
                      </Col>
                    </Row>

                    <div className='isoInputWrapper'>
                      <Col className='gutter-row isoInputWrapper descr-text' md={24}>
                        <p className='paragraph'>
                          We may contact you to verify the information that you have provided.
                          Moreover, in order to participate and use Resiliens for Clinicians,
                          acceptance of and adherence to certain Resiliens legal agreements is
                          required. Please review the following documents by clicking on the
                          highlighted link. Clicking on the checkbox signifies that you have read
                          the referenced agreement and agree with its terms. In order to use
                          Resiliens for Clinicians, you must agree to all of the following. If you
                          would like to receive paper copies of any of these documents for your
                          records, please contact{' '}
                          <strong>
                            <a href='mailto:info@resiliens.com'>info@resiliens.com</a>
                          </strong>
                          .
                        </p>
                      </Col>
                      {this.state.agreeError ? (
                        <Alert
                          message={this.state.agreeError}
                          type='error'
                          showIcon
                          style={{ marginBottom: '20px', display: 'flex' }}
                        />
                      ) : null}

                      <p style={{ margin: '40px 10px 25px 10px' }} className='rules-text'>
                        <Checkbox
                          onChange={e => this.setState({ checkBoxOne: e.target.checked })}
                          style={{ margin: '0 10px 0 0', float: 'left' }}
                          value={this.state.checkBoxOne}
                        />
                        By clicking here you signify your agreement to the{' '}
                        <a href='https://www.resiliens.com/terms' target='_blank' rel='noreferrer'>
                          Terms of Service
                        </a>{' '}
                        (Governs use of the online Dashboard tools and resources).
                      </p>

                      <p style={{ margin: '25px 10px' }} className='rules-text'>
                        <Checkbox
                          onChange={e => this.setState({ checkBoxTwo: e.target.checked })}
                          style={{ margin: '0 10px 0 0', float: 'left' }}
                          value={this.state.checkBoxTwo}
                        />
                        By clicking here you signify your review of Resiliensʼs current{' '}
                        <a
                          href='https://www.resiliens.com/privacy'
                          target='_blank'
                          rel='noreferrer'
                        >
                          Privacy Policy
                        </a>{' '}
                        (Provides current summary of Resiliensʼs personal data collection and use
                        practices).
                      </p>

                      <p style={{ margin: '25px 10px' }} className='rules-text'>
                        <Checkbox
                          onChange={e => this.setState({ checkBoxThree: e.target.checked })}
                          style={{ margin: '0 10px 0 0', float: 'left' }}
                          value={this.state.checkBoxThree}
                        />
                        By clicking here you signify your acceptance of Resiliensʼs{' '}
                        <a
                          href='https://www.resiliens.com/medical-professionals-agreement'
                          target='_blank'
                          rel='noreferrer'
                        >
                          Medical Professionals Agreement
                        </a>
                        . (What is the Medical Professionals Agreement?)
                      </p>

                      <p style={{ margin: '25px 10px' }} className='rules-text'>
                        <Checkbox
                          onChange={e => this.setState({ checkBoxFour: e.target.checked })}
                          style={{ margin: '0 10px 0 0', float: 'left' }}
                          value={this.state.checkBoxFour}
                        />
                        By clicking here you signify your acceptance of Resiliensʼs{' '}
                        <a
                          href='https://resiliens.com/HIPAA-Business-Associate-Addendum'
                          target='_blank'
                          rel='noreferrer'
                        >
                          Business Associates Agreement.
                        </a>{' '}
                        (What is the Business Associate Agreement?)
                      </p>
                    </div>
                  </div>
                </div>
                <div className='signup-bottom-btn'>
                  <Button
                    className='bt_portal-button -primary'
                    onClick={this.onNext}
                    loading={this.state.loading}
                  >
                    {currentIndex === 2 ? 'Sign up' : 'Next'}
                  </Button>
                </div>
              </div>
            </Row>
          )}
          <Modal
            centered
            style={{ top: 20 }}
            title='Confirm Email'
            visible={this.state.showConfirmSignupForm}
            onOk={this.confirmSignup}
            okText='Verify'
            className='account-exists-modal'
            cancelButtonProps={{ className: 'bt_portal-bt_portal-button -disabled -outlined' }}
            okButtonProps={{ type: 'primary', className: 'modal-btn' }}
            onCancel={this.handleCancel}
          >
            <div className='isoSignInForm show'>
              {this.state.confError ? (
                <Alert
                  message={
                    this.state.confirmationErrMsg || 'Something went wrong, Please try again.'
                  }
                  type='error'
                  showIcon
                  style={{ marginBottom: '20px' }}
                />
              ) : null}
              <p className='verification-text'>
                We have emailed a verification code to the email you entered. Please enter it in the
                box below and click the Verify button.
              </p>
              <div className='isoInputWrapper'>
                <Input
                  size='large'
                  type='text'
                  placeholder='Enter Confirmation Code'
                  name='signupConfirmationCode'
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </Modal>

          <Modal
            centered
            style={{ top: 40 }}
            title='User Already Exists.'
            visible={this.state.sysErr === 'User already exists'}
            onOk={this.resendSignUp}
            okText='Yes'
            okButtonProps={{ type: 'primary', className: 'modal-btn' }}
            onCancel={this.clearAll}
            cancelButtonProps={{ className: 'bt_portal-bt_portal-button -disabled -outlined' }}
            cancelText='No'
            className='account-exists-modal'
          >
            <p style={{ textAlign: 'center' }} className='msg'>
              An account with this email already exists since you signed up for one of our DBT Apps.
              Do you want to use the same account?
            </p>
          </Modal>
        </div>
      </SignInStyleWrapper>
    );
  }
}

// const logger = new Logger(SignIn);

export default SignIn;
